import { useState, useEffect } from "react";
import { HeroDataService } from "../../types/responsestate";
import { HeroLookup } from "../../types/dotes";
// import type { OpenDotaData, StratzData } from "../../types/dotes";

// import mergedata from "../../testdata/test-merged.json";

const getHeroVideoUrl = (hero: HeroLookup) => {
	if (hero.video) return hero.video;
	if (!hero.img) return "";
	return hero.img
		.replace("png", "webm")
		.replace("images", "videos")
		.replace("heroes/", "heroes/renders/");
};

const useDotaData = () => {
	const [result, setResult] = useState<HeroDataService<HeroLookup[]>>({
		status: "init",
	});
	useEffect(() => {
		// Merge the data here
		const fetchDotaData = async () => {
			try {
				// Merge the data
				const dottoBlob = import.meta.env.VITE_DOTTO_FUNC ?? `/api/dotto`;
				console.log(`🥮grim__dottoBlob==> ==> ==>dottoBlob`);
				console.log({grim__dottoBlob: dottoBlob});
				if (!dottoBlob) return;
				const retriveDotaData = await fetch(dottoBlob);
				if (!retriveDotaData.ok) {
					throw new Error(`HTTP error! Status: ${retriveDotaData.status}`);
				}
				console.log(`🥮grim__retriveDotaData==> ==> ==>retriveDotaData`);
				console.log({grim__retriveDotaData: retriveDotaData});
				const heroData: HeroLookup[] = await retriveDotaData.json();
				const normalizedHeroData = heroData.map((hero) => ({
					...hero,
					video: getHeroVideoUrl(hero),
				}));

				setResult({
					status: 'loaded',
					payload: normalizedHeroData
				});
			} catch (error) {
				setResult({
					status: 'error',
					error: error as Error
				});
			}
		};
		fetchDotaData();
	}, [])

	return result;
};

export default useDotaData;
